const merchandiseCredit = {
  merchandiseCredit: {
    noFile: 'Geen bestand gekozen',
    fileName: 'Bestandsnaam',
    software_service: 'Softwareservice',
    hardware_product: 'Hardwareproduct',
    sampleFileNameUs: 'Merchandisekrediet US',
    sampleFileNameAu: 'Merchandisekrediet AU',
    rowNumber: 'Rijnummer',
    errorMessage: 'Bericht'
  }
};

export default merchandiseCredit;
